export default __webpack_public_path__ + "files/1_3_4_Draft_Bioeconomy_Strategy_South_Bohemia_Czech_Republic.docx";